
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.471 1.804A.667.667 0 005.53.861L.862 5.528a.667.667 0 000 .943l4.667 4.666a.667.667 0 10.942-.942L2.943 6.666h7.724a.667.667 0 100-1.333H2.943L6.47 1.804z"}})])
          )
        }
      }
    